import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ConfirmProvider } from './components/ConfirmProvider';
import { RequireAuth, RequireAdmin } from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';

import UserHome from './pages/user/Home';
import ExamPage from './pages/user/Exam';
import MyResults from './pages/user/MyResults';
import ResultView from './pages/user/ResultView';

import AdminDashboard from './pages/admin/Dashboard';
import AdminQuestions from './pages/admin/Questions';
import AdminPapers from './pages/admin/Papers';
import AdminDepartments from './pages/admin/Departments';
import AdminImportExport from './pages/admin/ImportExport';
import AdminResults from './pages/admin/Results';
import AdminAttemptDetail from './pages/admin/AttemptDetail';
import AdminUsers from './pages/admin/Users';
import AdminUserActivity from './pages/admin/UserActivity';
import AdminUserActivityDetail from './pages/admin/UserActivityDetail';
import AdminUserActivityAttempt from './pages/admin/UserActivityAttempt';
import AdminSettings from './pages/admin/Settings';
import AdminAuditLog from './pages/admin/AuditLog';
import AdminReports from './pages/admin/Reports';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfirmProvider>
          <Routes>
          <Route path="/login" element={<Login />} />

          {/* Exam-taking is full-screen, no sidebar */}
          <Route path="/exam/:attemptId" element={<RequireAuth><ExamPage /></RequireAuth>} />

          <Route element={<RequireAuth><Layout /></RequireAuth>}>
            <Route path="/" element={<UserHome />} />
            <Route path="/my-results" element={<MyResults />} />
            <Route path="/my-results/:attemptId" element={<ResultView />} />

            <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            <Route path="/admin/questions" element={<RequireAdmin><AdminQuestions /></RequireAdmin>} />
            <Route path="/admin/papers" element={<RequireAdmin><AdminPapers /></RequireAdmin>} />
            <Route path="/admin/departments" element={<RequireAdmin><AdminDepartments /></RequireAdmin>} />
            <Route path="/admin/import-export" element={<RequireAdmin><AdminImportExport /></RequireAdmin>} />
            <Route path="/admin/results" element={<RequireAdmin><AdminResults /></RequireAdmin>} />
            <Route path="/admin/results/:attemptId" element={<RequireAdmin><AdminAttemptDetail /></RequireAdmin>} />
            <Route path="/admin/users" element={<RequireAdmin><AdminUsers /></RequireAdmin>} />
            <Route path="/admin/user-activity" element={<RequireAdmin><AdminUserActivity /></RequireAdmin>} />
            <Route path="/admin/user-activity/:userId" element={<RequireAdmin><AdminUserActivityDetail /></RequireAdmin>} />
            <Route path="/admin/user-activity/:userId/attempts/:attemptId" element={<RequireAdmin><AdminUserActivityAttempt /></RequireAdmin>} />
            <Route path="/admin/settings" element={<RequireAdmin><AdminSettings /></RequireAdmin>} />
            <Route path="/admin/audit-log" element={<RequireAdmin><AdminAuditLog /></RequireAdmin>} />
            <Route path="/admin/reports" element={<RequireAdmin><AdminReports /></RequireAdmin>} />
          </Route>
          </Routes>
        </ConfirmProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
